import { render } from "./star.vue?vue&type=template&id=0e587007&scoped=true"
import script from "./star.vue?vue&type=script&lang=js"
export * from "./star.vue?vue&type=script&lang=js"

import "./star.vue?vue&type=style&index=0&id=0e587007&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e587007"

export default script